import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '../services/translate/translate.service';

export type Wildcard = string | number | boolean;

@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  public transform(key: string, component: string | undefined = undefined, ...wildcards: Wildcard[]): Observable<string> {
    return this.translateService.translate(key, component, ...wildcards);
  }

}
